import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  popoverPaper: {
    width: 340,
    borderRadius: 0,
    border: '1px solid #F5F5F5',
    boxShadow: '0px 4px 8px -2px rgba(16,24,40,0.10), 0px 2px 4px -2px rgba(16,24,40,0.06)',
    marginTop: 8,
  },
  choiceContainer: {
    display: 'flex',
    padding: 16,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 16,
    backgroundColor: '#fff',
  },
  choiceRow: {
    width: '100%',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '&:hover': {
      backgroundColor: Colors.Grey1,
    },
    '&:focus-visible': {
      outline: '2px solid #1976d2',
      outlineOffset: 2,
    },
  },
  choiceTitle: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    letterSpacing: '0.64px',
    color: '#0F0F0F',
  },
  choiceSubtitle: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 200,
    letterSpacing: '0.56px',
    color: '#404040',
  },
  choiceDivider: {
    height: 1,
    backgroundColor: Colors.Grey3,
    width: '100%',
    margin: 0,
  },
  searchSection: {
    marginBottom: '16px',
  },
  searchField: {
    width: '100%',
    marginBottom: '8px',
  },
  searchIcon: {
    width: 20,
    height: 20,
    color: '#666',
  },
  filterChips: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  filterChip: {
    marginRight: '8px',
  },
  selectionInfo: {
    marginBottom: '16px',
    padding: '8px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
  },
  itemsList: {
    flex: 1,
    overflow: 'auto',
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '8px',
  },
  selectAllRow: {
    borderBottom: '1px solid #ddd',
    paddingBottom: '8px',
    marginBottom: '8px',
  },
  itemRow: {
    padding: '8px 0',
    borderBottom: '1px solid #ddd',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  itemInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  noItems: {
    textAlign: 'center',
    padding: '24px',
  },
}));

export default useStyles;
